export const GOOGLE_MAPS_API_KEY = 'GOOGLE_MAPS_API_KEY'
export const GOOGLE_MAPS_SERVICE_ID = 'google-maps-service'
